import * as mapboxgl_draw from "@mapbox/mapbox-gl-draw"
import { Feature, Point } from "geojson";

/**
 * Define os controles de pontos e polígonos do mapbox gl draw
 * 
 * Exemplo base dos estilos:
 * @see https://github.com/mapbox/mapbox-gl-draw/blob/main/docs/EXAMPLES.md
 */
export abstract class MapboxDrawCustom {
    // TODO: REMOVER custom_style e substituir suas referências por chamadas a createDraw
    static custom_style = new mapboxgl_draw({
        styles:[
            // ACTIVE (being drawn)
            // line stroke
            {
                "id": "gl-draw-line",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
                "layout": {
                  "line-cap": "round",
                  "line-join": "round"
                },
                "paint": {
                  "line-color": "#85a897",
                  "line-dasharray": [0.2, 2],
                  "line-width": 3
                }
            },
            // polygon fill
            {
              "id": "gl-draw-polygon-fill",
              "type": "fill",
              "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
              "paint": {
                "fill-color": ["case",
                ['!',['has', 'user_featureColor']], "#85a897",
                    ['get','user_featureColor']
                ],
                "fill-outline-color": "#85a897",
                "fill-opacity": 0.35
              }
            },
            // polygon mid points
            {
            'id': 'gl-draw-polygon-midpoint',
            'type': 'circle',
            'filter': ['all',
              ['==', '$type', 'Point'],
              ['==', 'meta', 'midpoint']],
            'paint': {
              'circle-radius': 3,
              'circle-color': ["case",
              ['!',['has', 'user_featureColor']], "#D20C0C",
                  ['get','user_featureColor']
              ],
                }
            },
            // polygon outline stroke
            // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
            {
              "id": "gl-draw-polygon-stroke-active",
              "type": "line",
              "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
              "layout": {
                "line-cap": "round",
                "line-join": "round"
              },
              "paint": {
                "line-color": "#85a897",
                "line-dasharray": [0.2, 2],
                "line-width": 3
              }
            },
            // vertex point halos
            {
              "id": "gl-draw-polygon-and-line-vertex-halo-active",
              "type": "circle",
              "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
              "paint": {
                "circle-radius": 5,
                "circle-color": "#FFF"
              }
            },
            // vertex points
            {
              "id": "gl-draw-polygon-and-line-vertex-active",
              "type": "circle",
              "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
              "paint": {
                "circle-radius": 3,
                "circle-color": ["case",
                ['!',['has', 'user_featureColor']], "#D20C0C",
                    ['get','user_featureColor']
                ],
              }
            },
        
            // INACTIVE (static, already drawn)
            // line stroke
            {
                "id": "gl-draw-line-static",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
                "layout": {
                  "line-cap": "round",
                  "line-join": "round"
                },
                "paint": {
                  "line-color": ["case",
                  ['!',['has', 'user_featureColor']], "#D20C0C",
                      ['get','user_featureColor']
                  ],
                  "line-width": 3
                }
            },
            // polygon fill
            {
              "id": "gl-draw-polygon-fill-static",
              "type": "fill",
              "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
              "paint": {
                "fill-color": ["case",
                ['!',['has', 'user_featureColor']], "#D20C0C",
                    ['get','user_featureColor']
                ],
                "fill-outline-color": "#85a897",
                "fill-opacity": 0.35
              }
            },
            // polygon outline
            {
              "id": "gl-draw-polygon-stroke-static",
              "type": "line",
              "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
              "layout": {
                "line-cap": "round",
                "line-join": "round"
              },
              "paint": {
                "line-color": "#85a897",
                "line-width": 3
              }
            }
          ],
        displayControlsDefault: false,
        // Select which mapbox-gl-draw control buttons to add to the map.
        controls: {
          polygon: true,
          trash: true
        },
        userProperties: true
      });

    public static createDraw(point: boolean = false) {
      return new mapboxgl_draw({
        styles:[
            // ACTIVE (being drawn)
            // line stroke
            {
                "id": "gl-draw-line",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
                "layout": {
                  "line-cap": "round",
                  "line-join": "round"
                },
                "paint": {
                  "line-color": "#85a897",
                  "line-dasharray": [0.2, 2],
                  "line-width": 3
                }
            },
            // polygon fill
            {
              "id": "gl-draw-polygon-fill",
              "type": "fill",
              "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
              "paint": {
                "fill-color": ["case",
                ['!',['has', 'user_featureColor']], "#85a897",
                    ['get','user_featureColor']
                ],
                "fill-outline-color": "#85a897",
                "fill-opacity": 0.35
              }
            },
            // polygon mid points
            {
            'id': 'gl-draw-polygon-midpoint',
            'type': 'circle',
            'filter': ['all',
              ['==', '$type', 'Point'],
              ['==', 'meta', 'midpoint']],
            'paint': {
              'circle-radius': 3,
              'circle-color': ["case",
              ['!',['has', 'user_featureColor']], "#D20C0C",
                  ['get','user_featureColor']
              ],
                }
            },
            // polygon outline stroke
            // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
            {
              "id": "gl-draw-polygon-stroke-active",
              "type": "line",
              "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
              "layout": {
                "line-cap": "round",
                "line-join": "round"
              },
              "paint": {
                "line-color": "#85a897",
                "line-dasharray": [0.2, 2],
                "line-width": 3
              }
            },
            // vertex point halos
            {
              "id": "gl-draw-polygon-and-line-vertex-halo-active",
              "type": "circle",
              "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
              "paint": {
                "circle-radius": 5,
                "circle-color": "#FFF"
              }
            },
            // vertex points
            {
              "id": "gl-draw-polygon-and-line-vertex-active",
              "type": "circle",
              "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
              "paint": {
                "circle-radius": 3,
                "circle-color": ["case",
                ['!',['has', 'user_featureColor']], "#D20C0C",
                    ['get','user_featureColor']
                ],
              }
            },
        
            // INACTIVE (static, already drawn)
            // line stroke
            {
                "id": "gl-draw-line-static",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
                "layout": {
                  "line-cap": "round",
                  "line-join": "round"
                },
                "paint": {
                  "line-color": ["case",
                  ['!',['has', 'user_featureColor']], "#D20C0C",
                      ['get','user_featureColor']
                  ],
                  "line-width": 3
                }
            },
            // polygon fill
            {
              "id": "gl-draw-polygon-fill-static",
              "type": "fill",
              "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
              "paint": {
                "fill-color": ["case",
                ['!',['has', 'user_featureColor']], "#D20C0C",
                    ['get','user_featureColor']
                ],
                "fill-outline-color": "#85a897",
                "fill-opacity": 0.35
              }
            },
            // polygon outline
            {
              "id": "gl-draw-polygon-stroke-static",
              "type": "line",
              "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
              "layout": {
                "line-cap": "round",
                "line-join": "round"
              },
              "paint": {
                "line-color": "#85a897",
                "line-width": 3
              }
            },
            {
              'id': 'highlight-active-points',
              'type': 'circle',
              'filter': ['all',
                ['==', '$type', 'Point'],
                ['==', 'meta', 'feature'],
                ['==', 'active', 'true']],
              'paint': {
                'circle-radius': 7,
                'circle-color': '#000000',
                'circle-stroke-color': '#ff0000',
                'circle-stroke-width': 1,
              }
            },
            {
              'id': 'points-are-black',
              'type': 'circle',
              'filter': ['all',
                ['==', '$type', 'Point'],
                ['==', 'meta', 'feature'],
                ['==', 'active', 'false']],
              'paint': {
                'circle-radius': 5,
                'circle-color': '#000000'
              }
            }
          ],
        displayControlsDefault: false,
        // Select which mapbox-gl-draw control buttons to add to the map.
        controls: {
          polygon: true,
          trash: true,
          point: point,
        },
        userProperties: true
      });
    }

      public static recolorFeature(map_draw: mapboxgl_draw, feature: Feature<Point>,timestamp:string){
        let mapFeature = map_draw.get(feature.id as string)
        mapFeature.properties.featureColor = feature.properties.color[timestamp]
        map_draw.delete(feature.id as string)
        map_draw.add(mapFeature)

      }
}